import { render, staticRenderFns } from "./MyVideoClassRoom.vue?vue&type=template&id=60152072&scoped=true"
import script from "./MyVideoClassRoom.vue?vue&type=script&lang=js"
export * from "./MyVideoClassRoom.vue?vue&type=script&lang=js"
import style0 from "./MyVideoClassRoom.vue?vue&type=style&index=0&id=60152072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60152072",
  null
  
)

export default component.exports